const booking = {
  bookingInformation: "Booking Information",
  cancellationPolicy: "Cancellation Policy",
  ourCancellationPolicy: "Our Cancellation Policy",
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "This supersedes any cancellation policy in remarks above",
  thisBookingIsNonNefundable: "This booking is non-refundable",
  paymentTerms: "Payment Terms",
  paymentWillBeTakenFromYourDefault: "Payment will be taken from your default",
  paymentMethod: "payment method",
  afterTheFreeCancellationPeriodIfApplicable:
    "after the free cancellation period if applicable",
  prebook: "Prebook",
  guests: "Guests",
  payment: "Payment",
  byClicking: "By clicking",
  youAreAgreeingToOur: "you are agreeing to our",
  termsAndConditions: "Terms and Conditions",
  lastBookableDate: "Last Bookable Date",
  customerRemarksTextfield: "Customer Remarks",
  request: "Request",
};

export default booking;
